import React from "react";
import MyRouter from "pages/index";
import CacheClientProvider from "modules/core/services/query/components/CacheClientProvider";
import CustomerContextProvider from "./modules/customers/components/CustomerContextProvider";
import BookingSearchProvider from "./modules/booking/components/BookingSearchProvider";
import CustomerTheme from "./modules/customers/components/CustomerTheme";
import {OidcClientProvider} from "./modules/ui/context/OidcClientContext";

function App() {
    return (
        <CacheClientProvider>
            <CustomerContextProvider>
                <OidcClientProvider>
                    <CustomerTheme/>
                    <BookingSearchProvider>
                        <MyRouter/>
                    </BookingSearchProvider>
                </OidcClientProvider>
            </CustomerContextProvider>
        </CacheClientProvider>
    );
}

export default App;
